import { useTranslation } from 'react-i18next'

import { StarIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CustomerRating = ({ rating, size = 5 }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const isSelected = index => index <= rating

  if (!rating) return null

  return (
    <Styles.Container>
      <Text type="bodySRegular">{t('Valoración cliente')}:</Text>
      {[...Array(size)].map((_, index) => (
        <StarIcon
          key={index}
          size={24}
          weight={isSelected(index + 1) ? 'fill' : 'thin'}
          color={isSelected(index + 1) ? theme.colors.accent.hover : theme.colors.outline.default}
        />
      ))}
    </Styles.Container>
  )
}

export default CustomerRating
